import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import twitterFill from '@iconify/icons-eva/twitter-fill';
import linkedinFill from '@iconify/icons-eva/linkedin-fill';
import facebookFill from '@iconify/icons-eva/facebook-fill';
import instagramFilled from '@iconify/icons-ant-design/instagram-filled';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { sentenceCase } from 'change-case';
import { isAdminUser } from '../../../../utils/adminUserTypes';
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import { Box, Card, Grid, Avatar, Tooltip, Divider, Typography, IconButton,Button, LinearProgress,
  linearProgressClasses,
  Checkbox, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, CircularProgress } from '@material-ui/core';
// utils
import { fShortenNumber } from '../../../../utils/formatNumber';
//
import SvgIconStyle from '../../../SvgIconStyle';
import Label from 'src/components/Label';
import ViewProject from '../../../../pages/dashboard/ViewProject';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'src/routes/paths';
import moment from 'moment';
import { formatDateOnly } from 'src/utils/dateOnly';
import { UserMoreMenu } from '../list';
import axios from 'axios';
import { REST_API_END_POINT, FacilityTypes } from 'src/constants/Defaultvalues';
import ConfirmationPopup from 'src/components/confirmationPopup';
import { useSnackbar } from 'notistack';
import { useState, useCallback } from 'react';
import { UploadMultiFile } from 'src/components/upload';
import { supabase } from 'src/supabase/supabaseClient';
import briefcaseFill from '@iconify/icons-eva/briefcase-fill';
import bellFill from '@iconify/icons-eva/bell-fill';
import QuickbookLogo from 'src/assets/quickbookLogo-removebg-preview.png'
import EstimateJobStageLabel from '../EstimateJobStageLabel';
// ----------------------------------------------------------------------

const CardMediaStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  justifyContent: 'center',
  paddingTop: 'calc(100% * 9 / 16)',
  '&:before': {
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
    //  backdropFilter: 'blur(3px)',
     WebkitBackdropFilter: 'blur(3px)', // Fix on Mobile
    borderTopLeftRadius: theme.shape.borderRadiusMd,
    borderTopRightRadius: theme.shape.borderRadiusMd,
    // backgroundColor: alpha(theme.palette.primary.darker, 0.72)
  }
}));

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
  // background: `url(${src}) center/cover no-repeat`
});

// ----------------------------------------------------------------------

function InfoItem(number) {
  return (
    <Grid item xs={4}>
      <Typography variant="caption" sx={{ mb: 0.5, color: 'text.secondary', display: 'block' }}>
        Follower
      </Typography>
      <Typography variant="subtitle1">{fShortenNumber(number)}</Typography>
    </Grid>
  );
}

// UserCard.propTypes = {
//   user: PropTypes.object.isRequired
// };

const IconWrapperStyle = styled('div')(({ theme }) => ({
  width: 25,
  height: 28,
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '5px',
  color: theme.palette.success.main,
  // backgroundColor: alpha(theme.palette.success.main, 0.16),
}));

export default function EstimateJobCard({ user, handleClickOpenViewPage, setRenderCards, medal, setIsEdit, openViewPage,removePopupData, setOpenViewPage,projectId, setProjectId,projectName,setProjectName, handleFetchEditData,currentTab,handleCheckboxChange,renderCards,communityJob,JobNewCard}) {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const navigate=useNavigate()
  const currentDateUnix = moment();
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: `hsl(${120 - (progressValue * 1.2)}, ${60}%, 50%)`, // `hsl(${(progressValue * 1.2)}, ${60 + (progressValue * 0.4)}%, 50%)`
    },
  }));
  const { name, due_date,installation_date,installation_start_date,installation_end_date, id, status,cover_image, noServiceNoTask, member_count, task_count, job_note_count, img, logo='https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg' ,progressValue,hold,jobcost,job_category_name,job_class_name, community_name, customer_name,allInstallationCompleted,InstallCompleteStatus,attachment,isFromDesignOrder,doc_number,syncWithQuickbooks,est_doc_number,installation_acceptance ,request_id, is_split_order, for_parent_facility, origin_facility_id,customer_logo,rush, is_rejected, rejection_reason, rejection_file, rejected_at, rejected_by_name, quotation_status } = user;                 
  const isEstimateVoided = Number(quotation_status) === 12;
  const showVoidMutedStyle = isEstimateVoided;
  const [isDelete,setIsDelete] = useState(false)
  const [openHoldPopup, setOpenHoldPopup] = useState(false);
  const [holdReason, setHoldReason] = useState('');
  const [isSubmittingHold, setIsSubmittingHold] = useState(false);
  const [holdReasonError, setHoldReasonError] = useState('');
  const [openRejectPopup, setOpenRejectPopup] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [rejectFiles, setRejectFiles] = useState([]);
  const [isSubmittingReject, setIsSubmittingReject] = useState(false);
  const [isUploadingRejectFile, setIsUploadingRejectFile] = useState(false);
  const [isSubmittingRestore, setIsSubmittingRestore] = useState(false);
  const isJobRejected = is_rejected === 1 || is_rejected === '1';

  const filteredAttachments = attachment?.filter(imageItem=>(imageItem?.file_type?.startsWith("image") || imageItem?.file_type === "img")) || []
  let userData = JSON.parse(localStorage.getItem('user'))
  const CompletedStatus = InstallCompleteStatus ===1? 'Installed' : InstallCompleteStatus === 2 ? 'Picked Up':InstallCompleteStatus === 3? 'Shipped' : 'Completed'
  const explodedPermissions =userData?.exploded_permissions
  const hasHoldEstimateJobsPermission = explodedPermissions?.some((permission) => ['Hold Estimate Jobs'].includes(permission)) ? true : false
  const hasEstimateJobCostPermission = explodedPermissions?.some((permission) => ['Manage Estimate Job Cost'].includes(permission)) ? true : false
  const handleDeleteTask = (status)=>{
    try {
      // const  user  = JSON.parse(window.localStorage.getItem('user')
      let newStatus = 0
      if ( status === 0 ){
        newStatus = 1
      }else if ( status === 2 ){
        newStatus = 2
      }else{
        newStatus = 0
      }
      axios.post(`${REST_API_END_POINT}project/delete-project`,{ id: Number(id), status: newStatus },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 4 || response.data.status === 2 || response.data.status === 1){
          enqueueSnackbar(response.data.message, { variant: 'success' });
          setRenderCards(true)
        }else if(response.data.status === 5 || response.data.status === 3 || response.data.status === 0){
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        setIsDelete(false)
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }

  const handleRejectFileDrop = useCallback(
    async (acceptedFiles) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return;
      setIsUploadingRejectFile(true);
      try {
        const uploadedFiles = [];
        for (const file of acceptedFiles) {
          const timestamp = Date.now();
          // This removes all #, %, &, + and other dangerous URL characters
const sanitizedName = file.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');;
          const fileName = `${timestamp}_${sanitizedName}`;
          const filePath = `estimate-job/rejected/${fileName}`;
          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);
          if (uploadError) throw uploadError;
          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);
          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }
          uploadedFiles.push({
            url: publicUrlData.publicUrl,
            file_type: file.type,
            original_name: file.name,
          });
        }
        setRejectFiles((prev) => [...(Array.isArray(prev) ? prev : []), ...uploadedFiles]);
      } catch (err) {
        enqueueSnackbar(`Upload failed: ${err.message}`, { variant: 'error' });
      } finally {
        setIsUploadingRejectFile(false);
      }
    },
    [enqueueSnackbar],
  );

  const handleRejectEstimateJob = async () => {
    if (!rejectReason.trim()) {
      enqueueSnackbar('Please fill rejected reason', { variant: 'warning' });
      return;
    }
    try {
      setIsSubmittingReject(true);
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}project/reject-estimate-job`,
        {
          projectId: Number(id),
          request_id,
          userId: user.user_id,
          reason: rejectReason,
          rejectionFiles: rejectFiles,
        },
        { headers: { 'Content-Type': 'application/json' } },
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setOpenRejectPopup(false);
        setRejectReason('');
        setRejectFiles([]);
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message || 'Failed to reject', { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Something went wrong while rejecting', { variant: 'error' });
    } finally {
      setIsSubmittingReject(false);
    }
  };

  const handleRestoreEstimateJob = async () => {
    try {
      setIsSubmittingRestore(true);
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}project/restore-rejected-estimate-job`,
        {
          projectId: Number(id),
          request_id,
          userId: user.user_id,
        },
        { headers: { 'Content-Type': 'application/json' } },
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message || 'Failed to restore', { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Something went wrong while restoring', { variant: 'error' });
    } finally {
      setIsSubmittingRestore(false);
    }
  };

  const handleUpdateHoldStatus = async (reason) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}project/update-job-hold-status`,
        {
          projectId: Number(id),
          userId: user.user_id,
          request_id: request_id,
          reason: reason || '',
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  };

  return (
   <>
      <Card sx={{
        transition: 'transform 0.2s',
        ml: 2,
        '&:hover': {
          transform: 'scale(1.02)',
        },
        ...(showVoidMutedStyle && {
          position: 'relative',
          backgroundColor: theme.palette.mode === 'light'
            ? alpha(theme.palette.grey[500], 0.14)
            : alpha(theme.palette.grey[600], 0.28),
          filter: 'grayscale(75%)',
          opacity: 0.68,
          '&::after': {
            content: '"VOID"',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%) rotate(-10deg)',
            color: theme.palette.error.main,
            fontWeight: 800,
            fontSize: '20px',
            letterSpacing: '2px',
            zIndex: 10,
            opacity: 0.4,
            pointerEvents: 'none',
          },
        }),
          ...(is_split_order && {
            border: `1px solid ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
              theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
              theme.palette.grey[500]}`
          }),
          ...(is_split_order && {
            boxShadow: `0 -2px 8px ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
              theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
              theme.palette.grey[500]}40, 0 4px 12px ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
              theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
              theme.palette.grey[500]}30, 0 2px 6px ${FacilityTypes.find(facility => facility.id === origin_facility_id).color ? 
              theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
              theme.palette.grey[500]}20`
          }),
      }}
        >
        <Box sx={{ position: 'absolute', top: 8, left: 8, zIndex: 10, padding: '12px' }}>
          {currentTab === 'Post Production'? <Checkbox
            onChange={(e) => handleCheckboxChange(user.id, e.target.checked,user)}
          />
          :
            <img width={25} height={25} src={medal}/>
          }
        </Box>
        {
          JobNewCard ? 
          <Box sx={{ position: 'absolute', top: 8, left: '20%', zIndex: 10, padding: '12px' }}> 
          <Label variant="filled">
            <IconWrapperStyle>
              <Icon width={20} height={20} icon={briefcaseFill} />
            </IconWrapperStyle>
            New
          </Label>
        </Box> :''
        }
        <Box sx={{ position: 'absolute', top: 8, left: '50%', zIndex: 10, padding: '12px' }}> 
        {/* {isJobRejected ? <Label variant="filled" color="error">Rejected</Label> : ''}
        {hold===1?<Label variant="filled" color="warning">Hold</Label>:""} */}
          {currentTab === 'Post Production'? <img width={25} height={25} src={medal}/> : ""}
        </Box>
        <Box sx={{ position: 'absolute',top: {xs: 100, sm: 100, md: 90, lg: 90, xl: 100 }, left: 12, zIndex: 10,display:"flex",justifyContent:"space-between" }}>
          {jobcost === 1 ?
            <Tooltip title="Material Out of Stock">
              <Typography>
                <Label variant='filled' color="error">Material Out of Stock</Label>
              </Typography>
            </Tooltip>
          : ""}
        </Box>
          {rush && (
              <Box
                sx={{
                  position: 'absolute',
                  cursor: 'pointer',
                  top: { xs: 100, sm: 100, md: 90, lg: 90, xl: 100 },
                  left: 13,
                  zIndex: 10,
                }}
              >
                <Typography>
                  <Label variant='filled' color="error">
                    RUSH
                  </Label>
                </Typography>
              </Box>
            )}

        {job_class_name ? 
        <Box sx={{ position: 'absolute',cursor:'pointer',top: {xs: 100, sm: 100, md: 90, lg: 90, xl: 100 }, right: 6, zIndex: 10 }}>
          <Tooltip title={`Job Class: ${job_class_name}`}>
            <Typography >
              <Label variant='filled' color="secondary">{job_class_name}</Label>
            </Typography>
          </Tooltip>
        </Box> : '' }
        {job_category_name ? 
        <Box sx={{ position: 'absolute',cursor:'pointer', top: {xs: 70, sm: 70, md: 60, lg: 60, xl: 70 }, right: 6, zIndex: 10 }}>
          <Tooltip title={`Job Type: ${job_category_name}`}>
          <Typography>
          <Label variant='filled' color="info">{job_category_name}</Label>
          </Typography>
          </Tooltip>
          </Box> : '' }
          <Typography sx={{ position: 'absolute',cursor:'pointer', top: {xs: 70, sm: 70, md: 60, lg: 60, xl: 70 }, left: 12, zIndex: 10 }}>
          {/* <Label
            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
             color={colors[status]} >
             {option.find(opt=>opt.id===status).value} 
            </Label> */}
            <EstimateJobStageLabel row={user} />
          </Typography>
        <Box sx={{ position: 'absolute', top: 0, right: 0, zIndex: 20, padding: '12px', display: 'flex', alignItems: 'center', gap: 1 }}>
        {/* Job Notes Notification Icon - Left of UserMoreMenu */}
        {job_note_count > 0 && (
          <Tooltip title={`${job_note_count} note${job_note_count > 1 ? 's' : ''}`}>
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: '#ff4444',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '2px solid white',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                animation: 'pulse 2s infinite',
                '@keyframes pulse': {
                  '0%': {
                    boxShadow: '0 0 0 0 rgba(255, 68, 68, 0.7)',
                  },
                  '70%': {
                    boxShadow: '0 0 0 10px rgba(255, 68, 68, 0)',
                  },
                  '100%': {
                    boxShadow: '0 0 0 0 rgba(255, 68, 68, 0)',
                  },
                },
              }}
            >
              <Icon width={14} height={14} icon={bellFill} />
            </Box>
          </Tooltip>
        )}
         {(userData?.user_type !=3 && currentTab!="Completed" ) && <UserMoreMenu hold={hold} text={status === 0 ? 'Activate' : null} 
          {...((currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' && currentTab != 'Completed' && currentTab !== 'Rejected' && status != 3 && !isJobRejected && status === 1 && hold !== 1) ? { 
            onHold:()=>{
            if(hasHoldEstimateJobsPermission){
              setOpenHoldPopup(true);
            }else{
              enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
            }
          }} : {})}
          {...((currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' && currentTab != 'Completed' && currentTab !== 'Rejected' && status != 3 && !isJobRejected && status === 1 && hold !== 1) ? {
            onReject: () => {
              setOpenRejectPopup(true);
              setRejectReason('');
              setRejectFiles([]);
            },
          } : {})}
          {...(isJobRejected ? {
            onRestore: () => handleRestoreEstimateJob(),
          } : {})}
          />}
        </Box>
        <CardMediaStyle sx={{cursor:'pointer'}} 
          // onClick={()=>handleClickOpenViewPage(id,name)}
          onClick={()=>{
            navigate(PATH_DASHBOARD.quotation.viewEstimateProject+id)
            // handleClickOpenViewPage(id,name)
          }}
        >
          <CoverImgStyle alt="cover" src={customer_logo ? customer_logo : (filteredAttachments?.length >0) ? filteredAttachments[0]?.name : (cover_image && cover_image !== 'DefaultThumbnailURL') ? cover_image : logo} />
        </CardMediaStyle>
        {/* <Grid container sx={{cursor:'pointer', mt: 0.5, textAlign: 'center',justifyContent:'space-between' ,display:'flex',flexDirection:'row',px:2 }}>
          <Typography>
            {customer_name ?
            <Label
              variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
              color="secondary"
            >
              <Tooltip title={
                is_split_order && for_parent_facility == 1 
                  ? FacilityTypes?.find(facility => facility.id === origin_facility_id)?.label || customer_name || ''
                  : customer_name || ''
              }>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: '12px',
                    cursor: 'pointer',
                    display: 'inline-block',
                    maxWidth: 60, // Adjust as necessary
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <span
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {is_split_order && for_parent_facility == 1 
                      ? FacilityTypes?.find(facility => facility.id === origin_facility_id)?.label || customer_name || ''
                      : customer_name || ''
                    }
                  </span>
                </Typography>
              </Tooltip>
            </Label> : '' }
          </Typography>
          <Typography>
            {
              community_name ? 
            <Label
              variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
              color="default"
            >
              <Tooltip title={community_name}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: '12px',
                    cursor: 'pointer',
                    display: 'inline-block',
                    maxWidth: 60, // Adjust as necessary
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <span
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {community_name}
                  </span>
                </Typography>
              </Tooltip>
            </Label> : ''
            }
          </Typography>
        </Grid> */}
        <Grid container sx={{cursor:'pointer', py: 1, textAlign: 'center',justifyContent:'space-between' ,display:'flex',flexDirection:'row',px:2 }}>
        <Tooltip title={name}>
          <Typography
            variant="subtitle1"
            align="center"
            onClick={()=>{
              navigate(PATH_DASHBOARD.quotation.viewEstimateProject+id)
              // handleClickOpenViewPage(id,name)
            }}
          
            sx={{
              alignItems:'center',
              justifyContent:'center',
              cursor: 'pointer',
              display: 'flex',
              maxWidth: 100, // Adjust as necessary
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: 'primary.main',
            }}
          >
            <span
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {name}
            </span>
          </Typography>
        </Tooltip>
        <Typography variant='subtitle2'>{` Members: ${member_count}`}</Typography>
        </Grid>
      
  
        <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: syncWithQuickbooks ? 'space-between' : 'center',
              alignItems: 'center',
              // my: 2,
              px: 1, mb: 1,
            }}
          >
          {/* {syncWithQuickbooks ? (
          <Box sx={{ display: 'flex' }}>
              <img
                src={QuickbookLogo}
                width={'50px'}
                height={'25px'}
              />
              <Typography >
                {doc_number ? `#${doc_number}` : ''}
              </Typography>
            </Box>
          ) : (
            ''
          )} */}
           {syncWithQuickbooks ? (
                      <Box sx={{ display: 'flex' , alignItems: 'center', mb: 1}}>
                        <img
                          src={QuickbookLogo}
                          width={'50px'}
                          height={'25px'}
                          style={{ marginTop: '10px' }}
                        />
                       
                       <Box sx={{ display: "flex", flexDirection: "column", }}>
                       
                            {
                          (installation_acceptance && est_doc_number) && (doc_number !==est_doc_number)?
                          <>
                            <Typography sx={{ marginTop: '13px',color:theme.palette.mode === 'light' ? "#53aa00" : "#90EE90"}}>
                          {est_doc_number ? `Job No: #${est_doc_number}` : ''}
                        </Typography>
                              <Typography sx={{ marginTop: '1px',color:theme.palette.mode === 'light' ? "#53aa00" : "#90EE90"}}>
                          {doc_number ? `Inv No: #${doc_number}` : ''}
                        </Typography>
                        </>
                          :
                          est_doc_number == null ?
                          <Typography sx={{ marginTop: '13px',color:theme.palette.mode === 'light' ? "#53aa00" : "#90EE90"}}>
                          {doc_number ? `Inv No: #${doc_number}` : ''}
                        </Typography>
                        :
                           <Typography sx={{ marginTop: '13px',color:theme.palette.mode === 'light' ? "#53aa00" : "#90EE90"}}>
                          {doc_number ? `Job No: #${doc_number}` : ''}
                          
                        </Typography>
                        }
                        </Box>
                      </Box>
                    ) : (
                      ''
                    )}
          

        <Typography variant="body2" align="center" >
          {(status!==3&& moment.unix(installation_date).isBefore(currentDateUnix))?(
           <Label 
              variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
              color={'error'}
              >
               Overdue:{installation_start_date && installation_end_date 
                 ? `${formatDateOnly(installation_start_date)} - ${formatDateOnly(installation_end_date)}`
                 : formatDateOnly(installation_date)
               }
           </Label>
           ):(
           <>
          Date:{installation_start_date && installation_end_date 
            ? `${formatDateOnly(installation_start_date)} - ${formatDateOnly(installation_end_date)}`
            : formatDateOnly(installation_date)
          }
          </>
          )}
        </Typography>
        {/* {isAdminUser (userData.user_type) && <Button onClick={() => {
                              navigate(PATH_DASHBOARD.project.jobCost+'/'+id)
                            }} sx={{ borderRadius: 20,marginBottom:1 }} variant="outlined">
                    Job Cost
                  </Button>} */}
                  
      </Box>
        {(isAdminUser (userData.user_type) || hasEstimateJobCostPermission) ?<>
          <Typography variant="body2"   style={{display:"flex", flexDirection:"column" ,alignItems:"center"}}>Job Cost</Typography>
          <Box sx={{ width: '100%', mr: 1 }}>
          
          <BorderLinearProgress variant="determinate" value={progressValue} />
        </Box>
       <Box sx={{ minWidth: 35, px: 1 }}>  
         <Typography variant="body2">{`${Math.round(progressValue)}%`}</Typography>
       </Box>
       </>:""}
        <ConfirmationPopup
          open={isDelete}
          handleClick={()=>handleDeleteTask(2)}
          handleClose={() => { setIsDelete(false) }}
          message={'You want to delete this Job. This action will also permanently delete the associated Sales Order and any related data.'}
        />
        <Dialog
          open={openHoldPopup}
          onClose={() => {
            setOpenHoldPopup(false);
            setHoldReason('');
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          BackdropProps={{ invisible: true }}
        >
          <DialogTitle id="alert-dialog-title">
            {hold === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {hold === 1
                ? 'You want to move this Job from Hold.'
                : 'You want to move this Job to Hold.'}
            </DialogContentText>
            {(hold === 0) ? (
              <TextField
                sx={{ width: 400 }}
                label="Reason"
                type="text"
                multiline
                minRows={3}
                maxRows={7}
                value={holdReason}
                onChange={(e) => {
                  setHoldReason(e.target.value);
                  if (holdReasonError) setHoldReasonError('');
                }}
                error={Boolean(holdReasonError)}
                helperText={holdReasonError}
              />
            ) : ''}
          </DialogContent>
          <DialogActions>
            <Button
              size="small"
              variant="contained"
              onClick={async () => {
                if ((hold === 0) && !holdReason.trim()) {
                  setHoldReasonError('Reason is required to put this Job on Hold.');
                  return;
                }

                setIsSubmittingHold(true);
                await handleUpdateHoldStatus(holdReason);
                setIsSubmittingHold(false);
                setOpenHoldPopup(false);
                setHoldReason('');
                setHoldReasonError('');
              }}
              disabled={isSubmittingHold}
            >
              {isSubmittingHold ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                'OK'
              )}
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={() => {
                setOpenHoldPopup(false);
                setHoldReason('');
              }}
              sx={{ color: theme.palette.error.main }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openRejectPopup}
          onClose={() => {
            if (isSubmittingReject || isUploadingRejectFile) return;
            setOpenRejectPopup(false);
          }}
          aria-labelledby="reject-estimate-job-title"
        >
          <DialogTitle id="reject-estimate-job-title">Reject Estimate Job</DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ mb: 2 }}>
              Rejecting will move this job and its estimate to the Rejected tab.
            </DialogContentText>
            <TextField
              fullWidth
              label="Reason For Rejection"
              type="text"
              multiline
              minRows={3}
              maxRows={7}
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              sx={{ mb: 2 }}
            />
            <UploadMultiFile
              showPreview
              files={rejectFiles || []}
              maxSize={1024 * 1024 * 1024}
              multiple
              onDrop={handleRejectFileDrop}
              onRemove={(file) => setRejectFiles((prev) => (Array.isArray(prev) ? prev : []).filter((f) => f !== file))}
              onRemoveAll={() => setRejectFiles([])}
              isUploading={isUploadingRejectFile}
            />
          </DialogContent>
          <DialogActions>
            <Button
              size="small"
              variant="contained"
              onClick={handleRejectEstimateJob}
              disabled={isSubmittingReject || isUploadingRejectFile}
            >
              {isSubmittingReject ? <CircularProgress size={20} color="inherit" /> : 'Submit Reject'}
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={() => {
                setOpenRejectPopup(false);
                setRejectReason('');
                setRejectFiles([]);
              }}
              sx={{ color: theme.palette.error.main }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </Card>
   </>
  );
}
